<div
  *ngIf="additionalProficiencyLevels"
  class="additional-proficiency-levels float-left"
>
  +{{additionalProficiencyLevels}}
</div>
